import styled from '@emotion/styled';

type ContainerProps = {
  $isMobile?: boolean;
};

export const Container = styled.div<ContainerProps>`
  position: relative;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
`;

export const BannerImage = styled.img`
  display: block;
  width: 100%;
  height: auto;
`;

export const ActionLink = styled.a<ContainerProps>`
  position: absolute;
  font-size: 0;
  text-indent: -9999px;
  overflow: hidden;
  white-space: nowrap;

  ${({ $isMobile }) =>
    $isMobile
      ? `
    right: 5%;
    bottom: 12%;
    width: 30%;
    height: 24%;
    min-width: 0;
    transform: none;
  `
      : `
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    min-width: 108px;
    height: 36px;
  `}

  &:focus-visible {
    outline: 2px solid #000fff;
    outline-offset: 2px;
  }
`;
